export enum MobilityTypes{
 None = "None",
 Training = "Training",
 Teaching = "Teaching",
 Studies = "Studies",
 Internship = "Internship",
}
